// extracted by mini-css-extract-plugin
export default {"contenedor":"styles_contenedor__gLCBn","image":"styles_image__jBPYC","text":"styles_text__bRiu2","stack":"styles_stack__Y2EWD"};